import {module} from "angular"
import "angular-ui-bootstrap";

export const integrationValidatorModule = module("integrationValidatorModule", [
    "ui.router"
])